module.exports = __webpack_public_path__ + "static/media/cartagena-17.f1da9e85.jpg";